import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all billOfEquipments
export const getBillOfEquipment = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// GET a single billOfEquipment
export const getBillOfEquipmentById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new billOfEquipment
export const createBillOfEquipment = async (billOfEquipmentData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/bill-of-equipment`, billOfEquipmentData);
    return response.data;
  } catch (error) {
    console.error("Error creating bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing billOfEquipment
export const updateBillOfEquipment = async (id, billOfEquipmentData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/bill-of-equipment/${id}`, billOfEquipmentData);
    return response.data;
  } catch (error) {
    console.error("Error updating bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// DELETE a billOfEquipment
export const deleteBillOfEquipment = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/bill-of-equipment/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting bill-of-equipment:", error.response?.data || error);
    throw error;
  }
};

// GET billOfEquipment by taskId
export const getBillOfEquipmentByTaskId = async (taskId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/bill-of-equipment`, {      params: { taskId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching bill-of-equipment:', error.response?.data || error);
    throw error;
  }
};
